<template>
    <svg width="18px" height="24px" viewBox="0 0 18 24" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g id="iconLock" transform="translate(-7 -4)">
            <path d="M20 10C20 7.79086 18.2091 6 16 6C13.8578 6 12.1089 7.68397 12.0049 9.80036L12 10L12 14L10 14L10 10C10 6.68629 12.6863 4 16 4C19.3137 4 22 6.68629 22 10L22 14L23 14C24.104 14 25 14.896 25 16L25 26C25 27.104 24.104 28 23 28L9 28C7.896 28 7 27.104 7 26L7 16C7 14.896 7.896 14 9 14L20 14L20 10Z" id="Path" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>